<template>
  <button
    @click="clicked"
    class="button-checkbox"
    :class="{ 'button-checkbox--active': active }"
    type="button"
  >
    <div class="button-checkbox__content">
      <mdicon
        v-if="rightIcon"
        class="button-checkbox__right-icon"
        :name="rightIcon"
        size="24"
      />
      <span class="button-checkbox__text">{{ text }}</span>
    </div>
  </button>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    text: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: null,
    },
    rightIcon: {
      type: String,
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clicked() {
      this.$emit("click", this.value);
    },
  },
};
</script>
